// @ts-ignore
import sha1 from 'sha-1';
import { getRequest, postRequest, putRequest, patchRequest, deleteRequest } from './util/requestAlias';
import { buildURL, buildRequestBody } from './util/requestHandler';
/**
 * 🔑添加关注
 *
 * 添加关注。
 */
export const addFollow = params => postRequest(buildURL('/users/{user_id}/followers', params));
/**
 * 🔐删除指定用户的头像，并重置为默认头像
 *
 * 删除指定用户的头像，并重置为默认头像。
 */
export const deleteAvatar = params => deleteRequest(buildURL('/users/{user_id}/avatar', params));
/**
 * 🔐删除指定用户的封面，并重置为默认封面
 *
 * 删除指定用户的封面，并重置为默认封面。
 */
export const deleteCover = params => deleteRequest(buildURL('/users/{user_id}/cover', params));
/**
 * 🔑取消关注
 *
 * 取消关注。
 */
export const deleteFollow = params => deleteRequest(buildURL('/users/{user_id}/followers', params));
/**
 * 🔑删除当前登录用户的头像，并重置为默认头像
 *
 * 删除当前登录用户的头像，并重置为默认头像。
 */
export const deleteMyAvatar = () => deleteRequest(buildURL('/user/avatar', {}));
/**
 * 🔑删除当前登录用户的封面，并重置为默认封面
 *
 * 删除当前登录用户的封面，并重置为默认封面。
 */
export const deleteMyCover = () => deleteRequest(buildURL('/user/cover', {}));
/**
 * 🔐禁用指定用户
 *
 * 禁用指定用户。
 */
export const disable = params => postRequest(buildURL('/users/{user_id}/disable', params, ['include']));
/**
 * 🔐批量禁用用户
 *
 * 批量禁用用户。
 */
export const disableMultiple = params => postRequest(buildURL('/users/{user_ids}/disable', params, ['include']));
/**
 * 🔐恢复指定用户
 *
 * 恢复指定用户。
 */
export const enable = params => postRequest(buildURL('/users/{user_id}/enable', params, ['include']));
/**
 * 🔐批量恢复用户
 *
 * 批量恢复用户。
 */
export const enableMultiple = params => postRequest(buildURL('/users/{user_ids}/enable', params, ['include']));
/**
 * 获取指定用户信息
 *
 * 若是管理员调用该接口、或当前登录用户读取自己的个人信息，将返回用户的所有信息。  其他情况仅返回部分字段（去掉了隐私信息，隐私字段已用 🔐 标明）
 */
export const get = params => getRequest(buildURL('/users/{user_id}', params, ['include']));
/**
 * 获取指定用户发表的回答
 *
 * 获取指定用户发表的回答。
 */
export const getAnswers = params => getRequest(buildURL('/users/{user_id}/answers', params, ['page', 'per_page', 'order', 'include']));
/**
 * 获取指定用户发表的文章
 *
 * 获取指定用户发表的文章。
 */
export const getArticles = params => getRequest(buildURL('/users/{user_id}/articles', params, ['page', 'per_page', 'order', 'include']));
/**
 * 获取指定用户发表的评论
 *
 * 获取指定用户发表的评论。
 */
export const getComments = params => getRequest(buildURL('/users/{user_id}/comments', params, ['page', 'per_page', 'order', 'include']));
/**
 * 获取指定用户关注的用户列表
 *
 * 获取指定用户关注的用户列表。
 */
export const getFollowees = params => getRequest(buildURL('/users/{user_id}/followees', params, ['page', 'per_page', 'include']));
/**
 * 获取指定用户的关注者
 *
 * 获取指定用户的关注者。
 */
export const getFollowers = params => getRequest(buildURL('/users/{user_id}/followers', params, ['page', 'per_page', 'include']));
/**
 * 获取指定用户关注的文章列表
 *
 * 获取指定用户关注的文章列表。
 */
export const getFollowingArticles = params => getRequest(buildURL('/users/{user_id}/following_articles', params, ['page', 'per_page', 'include']));
/**
 * 获取指定用户关注的提问列表
 *
 * 获取指定用户关注的提问列表。
 */
export const getFollowingQuestions = params => getRequest(buildURL('/users/{user_id}/following_questions', params, ['page', 'per_page', 'include']));
/**
 * 获取指定用户关注的话题列表
 *
 * 获取指定用户关注的话题列表。
 */
export const getFollowingTopics = params => getRequest(buildURL('/users/{user_id}/following_topics', params, ['page', 'per_page', 'include']));
/**
 * 获取用户列表
 *
 * 仅管理员可使用 email 参数进行搜索。  仅管理员可获取已禁用的用户列表。
 */
export const getList = (params = {}) => getRequest(buildURL('/users', params, ['page', 'per_page', 'order', 'include', 'user_id', 'username', 'email', 'disabled']));
/**
 * 🔑获取当前登录用户的信息
 *
 * 获取当前登录用户的信息。
 */
export const getMine = (params = {}) => getRequest(buildURL('/user', params, ['include']));
/**
 * 🔑获取当前登录用户发表的回答
 *
 * 获取当前登录用户发表的回答。
 */
export const getMyAnswers = (params = {}) => getRequest(buildURL('/user/answers', params, ['page', 'per_page', 'order', 'include']));
/**
 * 🔑获取当前登录用户发表的文章
 *
 * 获取当前登录用户发表的文章。
 */
export const getMyArticles = (params = {}) => getRequest(buildURL('/user/articles', params, ['page', 'per_page', 'order', 'include']));
/**
 * 🔑获取当前登录用户发表的评论
 *
 * 获取当前登录用户发表的评论。
 */
export const getMyComments = (params = {}) => getRequest(buildURL('/user/comments', params, ['page', 'per_page', 'order', 'include']));
/**
 * 🔑获取当前登录用户关注的用户
 *
 * 获取当前登录用户关注的用户。
 */
export const getMyFollowees = (params = {}) => getRequest(buildURL('/user/followees', params, ['page', 'per_page', 'include']));
/**
 * 🔑获取当前登录用户的关注者
 *
 * 获取当前登录用户的关注者。
 */
export const getMyFollowers = (params = {}) => getRequest(buildURL('/user/followers', params, ['page', 'per_page', 'include']));
/**
 * 🔑获取登录用户关注的文章
 *
 * 获取登录用户关注的文章。
 */
export const getMyFollowingArticles = (params = {}) => getRequest(buildURL('/user/following_articles', params, ['page', 'per_page', 'include']));
/**
 * 🔑获取登录用户关注的提问
 *
 * 获取登录用户关注的提问。
 */
export const getMyFollowingQuestions = (params = {}) => getRequest(buildURL('/user/following_questions', params, ['page', 'per_page', 'include']));
/**
 * 🔑获取登录用户关注的话题
 *
 * 获取登录用户关注的话题。
 */
export const getMyFollowingTopics = (params = {}) => getRequest(buildURL('/user/following_topics', params, ['page', 'per_page', 'include']));
/**
 * 🔑获取登录用户发表的提问
 *
 * 获取登录用户发表的提问。
 */
export const getMyQuestions = (params = {}) => getRequest(buildURL('/user/questions', params, ['page', 'per_page', 'order', 'include']));
/**
 * 获取指定用户发表的提问
 *
 * 获取指定用户发表的提问。
 */
export const getQuestions = params => getRequest(buildURL('/users/{user_id}/questions', params, ['page', 'per_page', 'order', 'include']));
/**
 * 验证邮箱并创建账号
 *
 * 返回用户信息。
 */
export const register = params => {
  if (params.password) {
    params.password = sha1(params.password);
  }
  return postRequest(buildURL('/users', params, ['include']), buildRequestBody(params, ['email', 'email_code', 'username', 'password']));
};
/**
 * 发送重置密码邮箱验证码
 *
 * 若返回参数中含参数 &#x60;captcha_token&#x60; 和 &#x60;captcha_image&#x60;，表示下次调用该接口时，需要用户输入图形验证码， 并把 &#x60;captcha_token&#x60; 和 &#x60;captcha_code&#x60; 参数传递到服务端。
 */
export const sendPasswordResetEmail = params => postRequest(buildURL('/user/password/email', params), buildRequestBody(params, ['email', 'captcha_token', 'captcha_code']));
/**
 * 发送注册邮箱验证码
 *
 * 若返回信息中含参数 &#x60;captcha_token&#x60; 和 &#x60;captcha_image&#x60;，表示下次调用该接口时，需要用户输入图形验证码， 并把 &#x60;captcha_token&#x60; 和 &#x60;captcha_code&#x60; 参数传递到服务端。
 */
export const sendRegisterEmail = params => postRequest(buildURL('/user/register/email', params), buildRequestBody(params, ['email', 'captcha_token', 'captcha_code']));
/**
 * 🔐更新指定用户信息
 *
 * 更新指定用户信息。
 */
export const update = params => patchRequest(buildURL('/users/{user_id}', params, ['include']), buildRequestBody(params, ['headline', 'bio', 'blog', 'company', 'location']));
/**
 * 🔑更新当前登录用户信息
 *
 * 更新当前登录用户信息。
 */
export const updateMine = params => patchRequest(buildURL('/user', params, ['include']), buildRequestBody(params, ['headline', 'bio', 'blog', 'company', 'location']));
/**
 * 验证邮箱并更新密码
 *
 * 验证邮箱并更新密码。
 */
export const updatePassword = params => {
  if (params.password) {
    params.password = sha1(params.password);
  }
  return putRequest(buildURL('/user/password', params), buildRequestBody(params, ['email', 'email_code', 'password']));
};
/**
 * 🔑上传当前登录用户的头像
 *
 * 上传当前登录用户的头像。
 */
export const uploadMyAvatar = params => {
  const formData = new FormData();
  formData.append('avatar', params.avatar);
  return postRequest(buildURL('/user/avatar'), formData);
};
/**
 * 🔑上传当前登录用户的封面
 *
 * 上传当前登录用户的封面。
 */
export const uploadMyCover = params => {
  const formData = new FormData();
  formData.append('cover', params.cover);
  return postRequest(buildURL('/user/cover'), formData);
};